module.exports = __webpack_public_path__ + "static/media/havana-10.5bc74d69.jpg";